export function validateCPF(cpf?: string) {
  if (!cpf) {
    return 'CPF é obrigatório';
  }

  const digits = cpf.replace(/\D/g, '');
  if (digits.length !== 11) {
    return 'CPF deve ter 11 dígitos';
  }

  if (/^(\d)\1+$/.test(digits)) {
    return 'CPF inválido';
  }

  // Calculate first check digit
  let sum = 0;
  for (let i = 0; i < 9; i++) {
    sum += parseInt(digits[i], 10) * (10 - i);
  }
  let firstCheck = (sum * 10) % 11;
  if (firstCheck === 10 || firstCheck === 11) {
    firstCheck = 0;
  }

  // Calculate second check digit
  sum = 0;
  for (let i = 0; i < 10; i++) {
    sum += parseInt(digits[i], 10) * (11 - i);
  }
  let secondCheck = (sum * 10) % 11;
  if (secondCheck === 10 || secondCheck === 11) {
    secondCheck = 0;
  }

  // Check if calculated digits match the provided ones
  if (
    parseInt(digits[9], 10) !== firstCheck ||
    parseInt(digits[10], 10) !== secondCheck
  ) {
    return 'CPF inválido';
  }
  return true;
}
